import { useMutation } from "@apollo/react-hooks";
import gql from 'graphql-tag';
import React, { useEffect, useRef } from "react";
import * as yup from 'yup';
import { Block, Form, FormGroup, Icon, Input, Loading, ModalThatSlides, Portlet, Text, TextInput } from '../../../../components';
import colors from "../../../../utils/colors";

export default function ModalCreate({ isOpen, onRequestClose, onCreate }) {
    const formRef = useRef(null);

    const [mutateUserCreate, { loading: loadingUserCreate }] = useMutation(
        gql`
            mutation userCreate(
                $name: String!
                $email: String!
                $password: String!
            ) {
                userCreate(
                    name: $name
                    email: $email
                    password: $password
                ) {
                    id
                    name
                    email
                }
            }
        `,
        {
            onError: () => { },
            onCompleted: (data) => {
                if (data && data.userCreate) {
                    !!onCreate && onCreate(data.userCreate);
                    !!onRequestClose && onRequestClose();
                }
            }
        }
    );

    useEffect(() => {
        if (!isOpen) {
            formRef.current && formRef.current.resetForm();
        }
    }, [isOpen]);

    return (
        <ModalThatSlides
            id="user-create"
            title="User create"
            width="820px"
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            actions={
                <Block row>
                    <Block
                        row
                        center
                        pl={16}
                        width={176}
                        height={52}
                        color={colors.grey02}
                        pointer={!loadingUserCreate}
                        onClick={() => {
                            formRef.current.handleSubmit();
                        }}
                    >
                        {loadingUserCreate ? <Loading /> : <Text size={14} height={28} color={colors.white01}>Save</Text>}
                    </Block>
                    <Block row center middle width={52} height={52} color={colors.grey01} pointer onClick={onRequestClose}>
                        <Icon name="close_16px" color={colors.white01} />
                    </Block>
                </Block>
            }
        >
            <Form
                innerRef={formRef}
                schema={yup.object().shape({
                    name: yup.string().required(),
                    email: yup.string().email().required(),
                    password: yup.string().required()
                })}
                onSubmit={(values) => {
                    if (!loadingUserCreate) {
                        mutateUserCreate({ variables: values });
                    }
                }}
            >
                {({
                    errors,
                    handleSubmit,
                }) => {
                    return (
                        <form onSubmit={handleSubmit} autoComplete="off">
                            <Portlet width="100%">
                                <FormGroup>
                                    <Block>
                                        <Input Component={TextInput} error={errors.name} name="name" label="Name" />
                                    </Block>
                                    <Block>
                                        <Input Component={TextInput} error={errors.email} name="email" label="Email" />
                                    </Block>
                                    <Block>
                                        <Input type="password" Component={TextInput} error={errors.password} name="password" label="Password" />
                                    </Block>
                                </FormGroup>
                            </Portlet>
                        </form>
                    )
                }}
            </Form>
        </ModalThatSlides>
    );
}